import React from 'react';

import PropTypes from 'prop-types';

import './SectionTitle.sass';

export const SectionTitle = ({ children }) => <div className="section-title">{children}</div>;

SectionTitle.propTypes = {
  children: PropTypes.node,
};
SectionTitle.defaultProps = {
  children: null,
};
